
export default {
  key: "contact",
  id: "contact_id",
  export: [],
  excel: {
     //max_row: "50000" 
  },
  sort_fields: [
    "contact_id",
    "name",
    "email"
  ],
  filters: {
    contact_id: {},
    name: {},
    email: {},
  },
  fields: [
    { key: "contact_id", width: 75 },
    { key: "name" },
    { key: "status", type: "boolean", width: 70 },
    { key: "email" },
    { type: "action-btn", width: 110 }
  ],
  structure: [
    ["name"],
    ["email"],
    ["status"],
  ],
  action: ["create", "edit", "view", "delete"],
  view: [
    ["name"],
    ["email"],
    ["status"],
  ],
  extra_components: {}
}